import angular from 'angular';

import '../../../main/factory/settlement';
import '../../../main/factory/authentication';
import '../../../core/main/factory/analytics';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.settlement.settlementExport", [
]).controller("merchant.application.module.settlement.settlementExport.controller", [
    "$scope", "$controller",
    "merchant.application.main.factory.settlement",
    "merchant.application.main.factory.authentication",
    "core.application.main.factory.analytics",
    function($scope, $controller, Settlement, Authentication, Analytics) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.settlementExport) {
            $scope.model.settlementExport = {};
        }

        $scope.model.heading = $scope.model.channel === 'IN_STORE_CARD' ? 'settlements:reconciliation-export' : 'settlements:settlement-export'
        $scope.model.buttonText = $scope.model.channel === 'IN_STORE_CARD' ? 'settlements:download-reconciliation-file' : 'settlements:download-settlement-file'

        $scope.model.settlementExport.exportType = "detail";
        $scope.model.settlementExport.fromDate = new Date();
        $scope.model.settlementExport.fromDate.setDate(1); // The default "from" date should be the first day of the month
        $scope.model.settlementExport.toDate = new Date();

        $scope.getSettlementFileUrl = function() {
            if (! $scope.form.$valid) {
                return "";
            }

            var merchantId = Authentication.merchantId();

            if ($scope.model.settlementExport.exportType === "detail") {
                return Settlement.getDetailExportCsvUrlForDates(
                    merchantId,
                    $scope.model.settlementExport.fromDate,
                    $scope.model.settlementExport.toDate,
                    $scope.model.channel
                );
            } else if ($scope.model.settlementExport.exportType === "summary") {
                return Settlement.getSummaryExportCsvUrlForDates(
                    merchantId,
                    $scope.model.settlementExport.fromDate,
                    $scope.model.settlementExport.toDate,
                    $scope.model.channel
                );
            }
        };

        $scope.sendAmplitudeEvent = function(eventName) {
            Analytics.sendAmplitudeEvent(eventName, {
                merchantId: Authentication.merchantId(),
                fromDate: $scope.model.settlementExport.fromDate,
                toDate: $scope.model.settlementExport.toDate,
                exportType: $scope.model.settlementExport.exportType,
                channel: $scope.model.channel
            })
        }

        $scope.fromDateFilter = function(date) {
            return date <= new Date(); // PAYL-1865 Future dates aren't allowed
        };

        $scope.toDateFilter = function(date) {
            if (date > new Date()) {
                // PAYL-1865 Future dates aren't allowed
                return false;
            }
            if (! date) {
                // PAYL-1717 null dates should return true as well so that the date can be cleared
                return true;
            }
            if (! $scope.model.settlementExport.fromDate) {
                // PAYL-1864 If the 'from' date isn't set then we still allow the 'to' date to be changed
                return true;
            }
            return date >= $scope.model.settlementExport.fromDate;
        };

        $scope.confirmFromDateLessThanToDate = function() {
            // make sure the 'to' date is greater than the 'from' date
            if ($scope.model.settlementExport.fromDate > $scope.model.settlementExport.toDate) {
                $scope.model.settlementExport.toDate = undefined;
            }
            // render 'to' date, otherwise the invalid dates in the
            // calendar popup won't be disabled properly
            $scope.form.toDate.$render();
        };

    }
]);
